import { Button } from "@/components/ui/button";
import { useState } from "react";
import NewsletterModal from "@/components/NewsletterModal";

const Footer = () => {
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);

  return (
    <>
      <footer className="border-t border-border bg-muted/30 py-12">
        <div className="container">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img 
                  src="/soundfield-logo-small.webp" 
                  alt="Soundfield Logo" 
                  className="h-8 w-8 rounded-lg"
                  width="32"
                  height="32"
                />
                <span className="text-xl font-bold">Soundfield</span>
              </div>
              <p className="text-sm text-muted-foreground">
                Your go-to source for music reviews, artist features, and industry insights.
              </p>
            </div>
            
            <div>
              <h3 className="font-semibold mb-4">Categories</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><a href="/" className="hover:text-foreground transition-colors">Latest</a></li>
                <li><a href="/?category=New Music" className="hover:text-foreground transition-colors">New Music</a></li>
                <li><a href="/?category=Industry News" className="hover:text-foreground transition-colors">Industry News</a></li>
                <li><a href="/?category=New Artist Spotlight" className="hover:text-foreground transition-colors">New Artist Spotlight</a></li>
                <li><a href="/?category=Opinion" className="hover:text-foreground transition-colors">Opinion</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold mb-4">Company</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><a href="/about" className="hover:text-foreground transition-colors">About</a></li>
                <li><a href="/contact" className="hover:text-foreground transition-colors">Contact</a></li>
                <li><a href="/privacy" className="hover:text-foreground transition-colors">Privacy</a></li>
                <li><a href="/terms" className="hover:text-foreground transition-colors">Terms</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold mb-4">Newsletter</h3>
              <p className="text-sm text-muted-foreground mb-4">
                Get the latest music reviews and industry insights delivered to your inbox.
              </p>
              <Button 
                className="w-full"
                onClick={() => setShowNewsletterModal(true)}
              >
                Subscribe
              </Button>
            </div>
          </div>
          
          <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
            © 2024 Soundfield. All rights reserved.
          </div>
        </div>
      </footer>
      
      <NewsletterModal 
        isOpen={showNewsletterModal} 
        onClose={() => setShowNewsletterModal(false)} 
      />
    </>
  );
};

export default Footer;